export default __webpack_public_path__ + "static/media/bird_icon.2fd3f500.svg";